import Process from 'utils/Process'

export const shouldLaunchNewTranslationProcess = currentProcess => Process.hasProcessFinished(currentProcess) || Process.hasProcessAborted(currentProcess) || !currentProcess